<template>
  <div class="AllChallengeDetailList">
    <div class="container-fluid margin-Top-2oint7Perc">
      <div class="row">
        <div class="col-md-6 col-lg-6 vertical-align">
          <div class="col-md-2 col-lg-2 text-align-right Padding-left-0px font-size-18px">
            Topic
          </div>
          <div class="col-md-8 col-lg-8 Padding-left-0px Padding-right-0px">
              <div class="col-md-12 col-lg-12 Padding-left-0px Padding-right-0px">
                <select class="form-control Padding-right-0px" v-model="getSelectedTopicId">
                  <option value=-1 disabled>Select</option>
                  <option v-for="topicObj in getTopicList" v-bind:key="topicObj.TopicId" v-bind:value="topicObj.TopicId">{{ topicObj.TopicName }}</option>
                </select>
              </div>
          </div>
          <div class="col-md-1 col-lg-1">
            <img :src="resetIcon" alt="imgedit" height="20" width="20" class="img-opacity cursor-pointer" @click="resetFilterAndList">  
          </div>
        </div>
        <div class="col-lg-6"></div>
      </div>
      <div class="row">
        <div class="table-responsive margin-Top-3Perc margin-left-3Point1Perc marginRight1point8perc">
          <table class="table table-striped">
            <thead>
              <tr v-if="getChallengeList.length !== 0">
                <th class="text-align-center text-valign-middle font-size-15px border-right col-md-2 col-lg-2">Title</th>
                <th class="text-align-center text-valign-middle font-size-15px border-right col-md-7 col-lg-7">Challenge Description</th>
                <!-- <th class="text-align-center text-valign-middle font-size-15px border-right col-md-1 col-lg-1">Challenge Video</th> -->
                <!-- <th class="text-align-center text-valign-middle font-size-15px border-right">Faculty Response Video</th> -->
                <!-- <th class="text-align-center text-valign-middle font-size-15px border-right">Topic</th>
                <th class="text-align-center text-valign-middle font-size-15px border-right">Created TS</th> -->
                <th class="text-align-center text-valign-middle font-size-15px col-md-3 col-lg-3">Action</th>            
              </tr>
            </thead>
            <tbody>
              <tr v-for="challengeObj in getChallengeList" :key="challengeObj.ChallengeId" v-bind:challengeObj = "challengeObj"> 
                <td class="text-align-center text-valign-middle border-right col-md-2 col-lg-2">{{challengeObj.Title}}</td>
                <td class="text-align-center text-valign-middle border-right col-md-7 col-lg-7 word-break-all">{{checkAndGetChallengeDesc(challengeObj.Desc)}}</td>
                <!-- <td class="text-align-center text-valign-middle border-right video-valign-middle col-md-1 col-lg-1">
                  <video width="200" height="120" controlsList="nodownload" controls  v-if="challengeObj.VideoUrl !== null">
                     <source v-bind:src="challengeObj.VideoUrl" type="video/mp4">
                  </video>
                </td> -->
                <!-- <td class="text-align-center text-valign-middle border-right video-valign-middle col-xs-2 col-sm-2 col-md-1 col-lg-1">
                  <video width="200" height="120" controlsList="nodownload" controls v-if="challengeObj.FacultyVideoUrl !== null">
                    <source v-bind:src="challengeObj.FacultyVideoUrl" type="video/mp4">
                  </video>
                </td> -->
                <!--
                <td class="text-align-center text-valign-middle border-right">{{challengeObj.TopicName}}</td>
                <td class="text-align-center text-valign-middle border-right">{{challengeObj.CreatedTS}}</td>
                -->
                <td class="text-align-center text-valign-middle col-md-3 col-lg-3">
                  <a class="cursor-pointer" @click="showConfirmationBoxAsTrue($event, true, challengeObj, 'copy')"> Copy </a>|
                  <a class="cursor-pointer" @click="openChallengeDetails($event,true,challengeObj)"> View </a>|
                  <a href="#" class="cursor-pointer" @click="openEditChallengeOverlay($event,true,challengeObj)"> Edit </a>|
                  <a href="#" class="cursor-pointer" @click="showConfirmationBoxAsTrue($event, true, challengeObj, 'delete')"> Delete </a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>  
      
    </div>
    <view-challenge-details-overlay v-if="openDetailsOverlay" v-bind:challengeObj="selectedChallengeObj" @closeOverlay="upateopenDetailsOverlayFlag"></view-challenge-details-overlay>
    <confirmation-alert v-if="showConfirmationBox" v-bind:dataObj="null" v-bind:prefixString="prefixString" v-bind:postfixString="postfixString" @showConfirmationBox="updateShowConfirmationAlertFlag" @userConfirmation="performPostConfirmationOperation"></confirmation-alert>
    <update-challenge-details-overlay v-bind:selectedChallengeObj="selectedChallengeObj" v-if="openEditOverlay" @refreshList="refreshChallengeList" @showSpinner="updateShowSpinnerFlag" @closeUpdateOverlay="upateopenEditDetailsOverlayFlag"></update-challenge-details-overlay>
    <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box> 
    <!-- Show Spinner -->
    <div class="animationload" v-show="showSpinner">
      <div class="osahanloading"></div>
    </div> 
    <loader></loader>
  </div>
</template>
<script>
import { topicService } from '@/server-util/topic-service'
import { constants } from '@/utils/constants'
import { challengeService } from '@/server-util/challenge-service'
import ViewChallengeDetails from '@/components/ViewChallengeDetailsOverlay'
import UpdateChallengeDetails from '@/components/UpdateChallengeOverlay'
import ConfirmationOverlay from '@/components/ConfirmationOverlay'
import AlertBox from '@/components/AlertOverlay'
import Loader from '@/components/dashboard/Loader'
import reset from '../assets/images/reset.svg'
export default {
  props: ['challengeList'],
  created: function () {
    this.getTopics()
    this.setDefaultValues()
  },
  data: function () {
    return {
      selectedChallengeObj: null,
      openDetailsOverlay: false,
      openEditOverlay: false,
      showConfirmationBox: false,
      prefixString: '',
      postfixString: '',
      showSpinner: false,
      showAlertDialog: false,
      errorMsg: '',
      selectedTopicId: -1,
      challengeListArr: [],
      resetIcon: reset
    }
  },
  methods: {
    checkAndGetChallengeDesc: function (challengeDesc) {
      if (challengeDesc !== undefined && challengeDesc !== 'undefined' && challengeDesc !== null && challengeDesc !== 'null' && challengeDesc !== '') {
        return challengeDesc
      } else {
        return 'Not Found.'
      }
    },
    setDefaultValues: function () {
      // AK: Initially Assign challengeList only
      this.challengeListArr = this.challengeList
      this.selectedTopicId = -1
    },
    resetFilterAndList: function () {
      this.challengeListArr = this.challengeList
      this.selectedTopicId = -1
      this.resetFilterAndList()
    },
    getTopics: function () {
      var _this = this
      var storeObj = this.$store
      if (
        storeObj.state.access_token !== undefined &&
        storeObj.state.access_token !== '' &&
        storeObj.state.access_token !== null
      ) {
        if (storeObj.state.topicList.length === 0) {
          // AK: Start showing spinner only if topic list not found
          // _this.showSpinner = true
          _this.$store.state.isLoading = true
        }

        topicService.getAllTopics(storeObj.state.access_token).then(
          responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Store it
              storeObj.state.topicList = responseObj.data
              // AK: Hide Spinner if its showing to user
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
              // console.log(JSON.stringify(storeObj.state.topicList))
            } else {
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
              _this.showAlertDialog = true
              _this.errorMsg =
                'Oops! Something went wrong. Please try again.'
            }
          },
          errorObj => {
            // AK: Hide Spinner if its showing to user
            // _this.showSpinner = false
            this.$store.state.isLoading = false
            _this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          }
        )
      } else {
        console.log(
          'ACCESS TOKEN is NULL hence declined GET TOPIC LIST OPERATION'
        )
      }
    },
    openEditChallengeOverlay: function (event, flagToUpdate, challengeObj) {
      // console.log(JSON.stringify(this.challengeList))
      this.selectedChallengeObj = challengeObj
      // AK: Open Edit Challenge overlay
      this.openEditOverlay = flagToUpdate
      // AK: Disable Background scrolling
      this.$store.state.isOverlayVisible = flagToUpdate
    },
    upateopenEditDetailsOverlayFlag (value) {
      // AK: used when user pressed done or X to close overlay
      this.openEditOverlay = value
      // AK: Enable Background scrolling
      this.$store.state.isOverlayVisible = value
    },
    openChallengeDetails: function (event, flagToUpdate, challengeObj) {
      this.selectedChallengeObj = challengeObj
      // AK: Open Details overlay
      this.openDetailsOverlay = flagToUpdate
      // AK: Disable Background scrolling
      this.$store.state.isOverlayVisible = flagToUpdate
    },
    upateopenDetailsOverlayFlag (value) {
      // AK: used when user pressed done or X to close overlay
      this.openDetailsOverlay = value
      // AK: Enable Background scrolling
      this.$store.state.isOverlayVisible = value
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    },
    updateShowConfirmationAlertFlag (value) {
      // AK: Used when user pressed close button of delete Challenge overlay
      this.showConfirmationBox = value
    },
    showConfirmationBoxAsTrue (event, flagToUpdate, challengeObj, selectedOperation = 'delete') {
      this.selectedChallengeObj = challengeObj
      switch (selectedOperation) {
        case 'delete':
          this.prefixString = 'Are you sure you want to delete'
          this.postfixString = ' \'' + this.selectedChallengeObj.Title + '\' challenge?'
          break
        case 'copy':
          this.prefixString = 'Are you sure you want to copy'
          this.postfixString = ' \'' + this.selectedChallengeObj.Title + '\' challenge?'
          break
      }
      // AK: Start Showing confirmation overlay
      this.showConfirmationBox = flagToUpdate
    },
    performPostConfirmationOperation (value) {
      this.showConfirmationBox = false
      if (value) {
        if (this.prefixString === 'Are you sure you want to delete') {
          this.deleteSelectedChallenge()
        } else {
          this.copySelectedChallenge()
        }
      }
    },
    copySelectedChallenge () {
      var _this = this
      var storeObj = this.$store
      if (
        this.selectedChallengeObj.ChallengeId !== undefined ||
        this.selectedChallengeObj.length > 0
      ) {
        // this.showSpinner = true
        this.$store.state.isLoading = true
        // AK: Hide Delete Confirmation Box
        _this.showConfirmationBox = false
        challengeService
          .copyMasterChallenge(storeObj.state.access_token, _this.selectedChallengeObj.ChallengeId)
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Refresh Challenge List
              _this.$emit('refreshChallengeList', true)
              // AK: hide showing spinner
              this.$store.state.isLoading = false
            } else {
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
              // this.showSpinner = false
              this.$store.state.isLoading = false
            }
          }, errorObj => {
            // AK: Hide Spinner
            // this.showSpinner = false
            this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log(
          'Selected Challenge Object is NULL hence declined COPY CHALLENGE OPERATION'
        )
      }
    },
    deleteSelectedChallenge () {
      var _this = this
      var storeObj = this.$store
      if (
        this.selectedChallengeObj.ChallengeId !== undefined ||
        this.selectedChallengeObj.length > 0
      ) {
        // this.showSpinner = true
        this.$store.state.isLoading = true
        // AK: Hide Delete Confirmation Box
        _this.showConfirmationBox = false
        challengeService
          .deleteChallenge(storeObj.state.access_token, _this.selectedChallengeObj.ChallengeId)
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Refresh Challenge List
              _this.$emit('refreshChallengeList', true)
              // AK: hide showing spinner
              // this.showSpinner = false
              this.$store.state.isLoading = false
            } else {
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
              // this.showSpinner = false
              this.$store.state.isLoading = false
            }
          }, errorObj => {
            // AK: Hide Spinner
            // this.showSpinner = false
            this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log(
          'Selected Lesson Object is NULL hence declined DELETE OPERATION'
        )
      }
    },
    updateShowSpinnerFlag (value) {
      // this.showSpinner = value
      this.$store.state.isLoading = value
    },
    refreshChallengeList (value) {
      if (value) {
        this.selectedTopicId = -1
        // Re-emit event (ChallegneAllChallenge file)
        this.$emit('refreshChallengeList', true)
      }
    },
    getChallengesByTopic: function () {
      var _this = this
      var storeObj = this.$store
      if (
        storeObj.state.access_token !== undefined ||
        storeObj.state.access_token !== '' ||
        storeObj.state.access_token !== null
      ) {
        _this.$store.state.isLoading = true
        challengeService.getChallengesAsPerTopicId(storeObj.state.access_token, this.selectedTopicId).then(
          responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Store it
              this.challengeListArr = responseObj.data
              // AK: Hide Spinner if its showing to user
              _this.$store.state.isLoading = false
            } else {
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
              _this.showAlertDialog = true
              _this.errorMsg =
                'Oops! Something went wrong. Please try again.'
            }
          },
          errorObj => {
            // AK: Hide Spinner if its showing to user
            // _this.showSpinner = false
            _this.$store.state.isLoading = false
            _this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          }
        )
      } else {
        console.log(
          'ACCESS TOKEN is NULL hence declined GET CHALLENGE LIST OPERATION USING TOPIC'
        )
      }
    }
  },
  components: {
    'view-challenge-details-overlay': ViewChallengeDetails,
    'confirmation-alert': ConfirmationOverlay,
    'alert-box': AlertBox,
    'update-challenge-details-overlay': UpdateChallengeDetails,
    'loader': Loader
  },
  computed: {
    getTopicList: {
      get: function () {
        return this.$store.state.topicList
      }
    },
    getSelectedTopicId: {
      get: function () {
        return this.selectedTopicId
      },
      set: function (newValue) {
        this.selectedTopicId = newValue
        if (this.selectedTopicId !== -1) {
          this.getChallengesByTopic()
        }
      }
    },
    getChallengeList: {
      get: function () {
        return this.challengeListArr
      }
    },
    isChallengeCreatedValue: {
      get: function () {
        return this.$store.state.isChallengeCreated
      }
    }
  },
  watch: {
    isChallengeCreatedValue: function (newValue, oldValue) {
      // AK: If challenge Created successfully then reset Topic filter and its flag too
      if (this.isChallengeCreatedValue) {
        this.selectedTopicId = -1
        this.resetFilterAndList()
        this.$store.state.isChallengeCreated = false
      }
    },
    challengeList: function (newValue, oldValue) {
      this.setDefaultValues()
    }
  }
}
</script>

<style scoped>
.text-align-right {
  text-align: right !important;
}
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.AllChallengeDetailList{
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.border-right
 {
   border-right: 1px solid #aaa !important;
 }
 .margin-Top-1Perc
{
	margin-top: 1%;
}
.margin-Top-2oint7Perc
{
	margin-top: 2.7%;
}
 .margin-right-minus3Perc
{
	margin-right: -3%;
}
.table-striped > tbody > tr:nth-child(2n + 1) > td,
  .table-striped > tbody > tr:nth-child(2n + 1) > th {
  background-color: #ddd;
 }
 .text-align-center {
  text-align: center !important;
}
.font-size-15px {
  font-size: 15px !important;
}
/* .text-valign-middle{
  vertical-align: middle;
} */
.vertical-align {
  display: flex;
  align-items: center;
}
.margin-left-3Point1Perc{
 margin-left: 3.1%;
}
.margin-right-1-point-1-Perc{
  margin-right: 1.1% !important;
}
.margin-Top-3Perc {
    margin-top: 3%;
}
.video-valign-middle{
  /* line-height: 1.5; */
  /* display: inline-block ; */
  vertical-align: middle !important;
}
a:link{
  color: #2c3e50 !important;
  text-decoration: none !important;
} 
a:visited{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a:hover{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a:active{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a{
  color: #2c3e50 !important;
}
.border-red{
  border: 1px solid red;
}
.border-yellow{
  border: 2px solid yellow;
}
.cursor-pointer
{
  cursor: pointer;
}
.table>thead>tr>th {
    vertical-align: bottom;
    border-bottom: 0px solid #aaaaaa;
}
.Padding-left-0px{
  padding-left: 0px !important;
}
.Padding-right-0px{
  padding-right: 0px !important;
}
.font-size-18px{
    font-size: 18px;
}
.marginRight1point8perc {
  margin-right: 1.8%;
}
.word-break-all {
  word-break: break-all;
}
</style>


// WEBPACK FOOTER //
// src/components/AllChallengeDetailList.vue